import { render, staticRenderFns } from "./bj-login.vue?vue&type=template&id=2209bc0d&scoped=true&"
import script from "./bj-login.vue?vue&type=script&lang=js&"
export * from "./bj-login.vue?vue&type=script&lang=js&"
import style0 from "./bj-login.vue?vue&type=style&index=0&id=2209bc0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2209bc0d",
  null
  
)

export default component.exports